import { Component } from '@angular/core';

@Component({
  selector: 'app-trading',
  imports: [],
  templateUrl: './trading.html',
  styleUrl: './trading.scss',
})
export class Trading {

}
